import { Box, Container, Typography } from "@mui/material";
import React from "react";
import Navbar from "../Components/Navbar";
import green_circle from "../Assets/Images/green_circle.png";
import CopyRight from "../Components/CopyRight";
import Footer from "../Components/Footer";



const TermsAndCondition = () => {
  return (
    <Box>
      <Box position={"relative"}>
        <Typography
          component={"img"}
          src={green_circle}
          sx={{
            position: "absolute",
            top: "0",
            left: "0",
            width: { sm: "55%", xs: "90%" },
            height: "130%",
          }}
        />
        <Navbar />

      
        <Container>
        <Box
            sx={{
                mb:"5rem",
                textAlign: "center",
                position:"relative",
              width: { sm: "100%", xs: "100%" },
              "& a": {
                color: "#0d6efd",
                textDecoration: "underline",
              },
              "& embed": {
                borderRadius: "10px",
                padding: "2rem 0 1rem",
                userSelect: "none",
                // pointerEvents:"none"
              },
            }}
          >
            <embed
              src="/termsOfService.pdf#toolbar=0"
              type="application/pdf"
            
              width={"100%"}
              height="800"
              style={{ borderRadius: "10px", padding: "2rem 0 1rem" }}
            ></embed>
          </Box>
          
        </Container>
      </Box>
    
      
      <Footer/>
      <CopyRight />
    </Box>
  );
};

export default TermsAndCondition;
